import { render, staticRenderFns } from "./TacosComponent.vue?vue&type=template&id=206fb536&"
import script from "./TacosComponent.vue?vue&type=script&lang=js&"
export * from "./TacosComponent.vue?vue&type=script&lang=js&"
import style0 from "./TacosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports